import { render, staticRenderFns } from "./Constructor.vue?vue&type=template&id=6ca55c5f&scoped=true&"
import script from "./Constructor.vue?vue&type=script&lang=js&"
export * from "./Constructor.vue?vue&type=script&lang=js&"
import style0 from "./Constructor.vue?vue&type=style&index=0&id=6ca55c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca55c5f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBreadcrumbs: require('/app/components/base/Breadcrumbs.vue').default})
